import {
  StoreLocatorQueryData_allDatoCmsContentStore_nodes,
  StoreLocatorQueryData_allDatoCmsContentStore_nodes_labels
} from "../../pages/__generated__/StoreLocatorQueryData";

export type StoreType = StoreLocatorQueryData_allDatoCmsContentStore_nodes;
export type StoreLabelType = StoreLocatorQueryData_allDatoCmsContentStore_nodes_labels;
export type StoreLabelUiType = StoreLabelType & {
  isSelected?: boolean;
};

interface StoreLocatorQueryData_allDatoCmsProduct_nodes_variants_variantDetail_thumbnail {
  url: string | null;
}

interface StoreLocatorQueryData_allDatoCmsProduct_nodes_variants_variantDetail {
  thumbnail: StoreLocatorQueryData_allDatoCmsProduct_nodes_variants_variantDetail_thumbnail | null;
}

interface StoreLocatorQueryData_allDatoCmsProduct_nodes_variants {
  variantDetail: StoreLocatorQueryData_allDatoCmsProduct_nodes_variants_variantDetail | null;
}

interface StoreLocatorQueryData_allDatoCmsProduct_nodes {
  slug: string | null;
  variants:
    | (StoreLocatorQueryData_allDatoCmsProduct_nodes_variants | null)[]
    | null;
}

export type OilProductType = StoreLocatorQueryData_allDatoCmsProduct_nodes;
export type OilProductUiType = OilProductType & {
  isSelected?: boolean;
};

export type GeolocationStateType = "inactive" | "active" | "loading";

export type MobileViewmodeType = "list" | "map";

export const MOBILE_DEFAULT_VIEWMODE: MobileViewmodeType = "list";

export const DESKTOP_LIST_WIDTH_POURC = 22; // % Left list width in pourcentage

export const TOP_BAR_HEIGHT = "152px";

export const TOP_BAR_HEIGHT_MOBILE = "146px";
